import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
} from "@themesberg/react-bootstrap";
import Select from "react-select";

import { UpdateProfile, reset } from "../../../features/profileSlice";
import {
  GetAllJenisPembiayaanDropdown,
  reset as resetJenisPembiayaan,
} from "../../../features/jenisPembiayaanSlice";

import api from "../../../api";
import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import { Link } from "react-router-dom";
import { getYearsList, validateNumericInput } from "../../../helpers/helper";
import { showSuccessDialog } from "../../../helpers/dialog.helper";
import { UserContext } from "../../../utils/ProtectedRoute";

const Profile = () => {
  const [isLocked, setIsLocked] = useState(true);
  const [dataFakultas, setDataFakultas] = useState([]);
  const [dataProdi, setDataProdi] = useState([]);
  const [newDataMahasiswa, setNewDataMahasiswa] = useState({
    username: "",
    nama: "",
    email: "",
    id_fakultas: "",
    id_prodi: "",
    id_role: "",
    nip: "",
    no_hp: "",
    alamat: "",
    tahun_angkatan: "",
    id_jenis_pembiayaan: "",
  });
  const dispatch = useDispatch();
  const {
    data: dataJenisPembiayaan,
    isLoading: isLoadingJenisPembiayaanList,
    isError: isErrorJenisPembiayaanList,
  } = useSelector((state) => state.jenisPembiayaan);
  const { isLoading, isError, message } = useSelector((state) => state.profile);
  const token = localStorage.getItem("token");

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  useEffect(() => {
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    dispatch(resetJenisPembiayaan());
    dispatch(GetAllJenisPembiayaanDropdown({ token }));
  }, [dispatch, token]);

  // call on init
  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Ambil data fakultas
        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });

        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));
        setDataFakultas(fakultasFormated);
      } catch (error) {
        console.log("ERROR FETCH FAKULTAS : ", error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [token]);

  // call if the id_fakultas is changed
  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Jika newUser.id_fakultas tidak kosong, ambil data prodi
        if (newDataMahasiswa.id_fakultas) {
          const prodiResponse = await axios.get(
            `${api}/master/prodi/get_by_fakultas_id/${newDataMahasiswa.id_fakultas}`,
            {
              cancelToken: source.token,
            }
          );
          const prodiFormated = prodiResponse.data.data.map((prodi) => ({
            value: prodi.id,
            label: prodi.nama,
          }));
          setDataProdi(prodiFormated);
        } else {
          // Jika newUser.id_fakultas kosong, set dataProdi menjadi array kosong
          setDataProdi([]);
        }
      } catch (error) {
        console.log("ERROR FETCH PRODI : ", error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [newDataMahasiswa.id_fakultas]);

  useEffect(() => {
    setNewDataMahasiswa({
      username: userData?.username,
      nama: userData?.nama,
      email: userData?.email,
      nip: userData?.nip,
      id_fakultas: userData?.id_fakultas,
      id_prodi: userData?.id_prodi,
      no_hp: userData?.no_hp,
      alamat: userData?.alamat,
      tahun_angkatan: userData?.tahun_angkatan,
      id_role: userData?.id_role,
      id_jenis_pembiayaan: userData?.id_jenis_pembiayaan,
    });
  }, [userData]);
  
  function getJenisPembiayaanList() {
    try {
      const result = dataJenisPembiayaan?.data?.map((item, i) => ({
        value: item,
        label: item.nama,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  const afterUpdateProfile = (result) => {
    setIsLocked(true);

    // update token
    localStorage.setItem(
      "userData",
      JSON.stringify({ status: result?.data?.status, id: result?.data?.id })
    );
    localStorage.setItem("token", result?.jwt_token);

    showSuccessDialog({
      title: "Berhasil!",
      msg: result?.message || "Berhasil mengupdate profile!",
    });
    window.location.href = "/profile";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(reset());
    dispatch(
      UpdateProfile({
        id: userData?.id,
        token,
        username: newDataMahasiswa.username,
        nama: newDataMahasiswa.nama,
        email: newDataMahasiswa.email,
        nip: newDataMahasiswa.nip,
        id_fakultas: newDataMahasiswa.id_fakultas,
        id_prodi: newDataMahasiswa.id_prodi,
        no_hp: newDataMahasiswa.no_hp,
        alamat: newDataMahasiswa.alamat,
        tahun_angkatan: newDataMahasiswa.tahun_angkatan,
        id_role: newDataMahasiswa.id_role,
        id_jenis_pembiayaan: newDataMahasiswa.id_jenis_pembiayaan,
        cb: afterUpdateProfile,
      })
    );
  };

  return (
    <AdminLayout>
      <Header>
        <Button onClick={() => setIsLocked(!isLocked)}>
          {isLocked ? "Edit" : "Kembali"}
        </Button>
      </Header>
      <Card>
        <FormPage
          userData={userData}
          dataFakultas={dataFakultas}
          dataProdi={dataProdi}
          handleSubmit={handleSubmit}
          newDataMahasiswa={newDataMahasiswa}
          setNewDataMahasiswa={setNewDataMahasiswa}
          isLocked={isLocked}
          isLoading={isLoading}
          isError={isError}
          message={message}
          isLoadingJenisPembiayaanList={isLoadingJenisPembiayaanList}
          dataJenisPembiayaan={getJenisPembiayaanList()}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  handleSubmit,
  newDataMahasiswa,
  setNewDataMahasiswa,
  dataFakultas,
  dataProdi,
  isLoadingJenisPembiayaanList,
  dataJenisPembiayaan,
  id,
  isLocked,
  isLoading,
  isError,
  message,
  userData,
}) => {
  return (
    <Card.Body>
      {isError && message ? (
        <Alert variant="danger">
          {message?.message || message?.errors[0].msg}
        </Alert>
      ) : null}
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="username">
              <Form.Label>{userData?.id_role != "HA05" ? 'Username' : 'Username/NIM'}</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Username"
                name="username"
                disabled={isLocked}
                value={newDataMahasiswa.username || ""}
                onChange={(e) =>
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    username: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="nama">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nama"
                name="nama"
                disabled={isLocked}
                value={newDataMahasiswa.nama || ""}
                onChange={(e) =>
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    nama: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Email"
                name="email"
                disabled
                value={newDataMahasiswa?.email || "-"}
                onChange={(e) =>
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    email: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="id_fakultas">
              <Form.Label>Fakultas</Form.Label>
              <Select
                options={dataFakultas}
                isDisabled={isLocked}
                placeholder="Pilih fakultas"
                value={dataFakultas.find(
                  (item) => item.value === newDataMahasiswa.id_fakultas
                )}
                autoFocus
                onChange={(e) => {
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    id_fakultas: e.value,
                  });
                }}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="id_prodi">
              <Form.Label>Prodi</Form.Label>
              <Select
                options={dataProdi}
                placeholder="Pilih Prodi"
                autoFocus
                value={dataProdi.find(
                  (item) => item.value === newDataMahasiswa.id_prodi
                )}
                isDisabled={!newDataMahasiswa.id_fakultas || isLocked}
                onChange={(e) => {
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    id_prodi: e.value,
                  });
                }}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="no_hp">
              <Form.Label>No. HP</Form.Label>
              <Form.Control
                type="text"
                placeholder="No. HP"
                name="no_hp"
                disabled={isLocked}
                value={newDataMahasiswa.no_hp || ""}
                onChange={(e) =>
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    no_hp: validateNumericInput(e.target.value, 16),
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="alamat">
              <Form.Label>Alamat</Form.Label>
              <Form.Control
                type="text"
                placeholder="-"
                name="alamat"
                disabled={isLocked}
                value={newDataMahasiswa.alamat || ""}
                onChange={(e) =>
                  setNewDataMahasiswa({
                    ...newDataMahasiswa,
                    alamat: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="role">
              <Form.Label>Role User</Form.Label>
              <Form.Control
                type="text"
                placeholder="Role User"
                name="role"
                disabled
                value={userData?.role || "-"}
              />
            </Form.Group>
          </Col>
          {userData?.id_role != "HA05" ? (
            <>
              <Col md={12} className="mb-3">
                <Form.Group id="nip">
                  <Form.Label>NIP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="NIP"
                    name="nip"
                    disabled={isLocked}
                    value={newDataMahasiswa.nip || ""}
                    onChange={(e) =>
                      setNewDataMahasiswa({
                        ...newDataMahasiswa,
                        nip: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </>
          ) : (
            <>
              <Col md={12} className="mb-3">
                <Form.Group id="tahun_angkatan">
                  <Form.Label>Tahun Angkatan</Form.Label>
                  <Select
                    options={getYearsList()}
                    placeholder="Pilih Tahun"
                    required
                    autoFocus
                    value={getYearsList().find(
                      (item) =>
                        `${item.value}` === `${newDataMahasiswa.tahun_angkatan}`
                    )}
                    isDisabled={isLocked}
                    onChange={(e) => {
                      setNewDataMahasiswa({
                        ...newDataMahasiswa,
                        tahun_angkatan: e.value,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Group id="id_jenis_pembiayaan">
                  <Form.Label>Jenis Pembiayaan</Form.Label>
                  <Select
                    options={dataJenisPembiayaan}
                    placeholder="Pilih jenis pembiayaan"
                    required
                    value={dataJenisPembiayaan?.find(
                      (e) => e.value.id === newDataMahasiswa?.id_jenis_pembiayaan
                    )}
                    isDisabled={isLocked}
                    autoFocus
                    isLoading={isLoadingJenisPembiayaanList}
                    onChange={(e) => {
                      setNewDataMahasiswa({
                        ...newDataMahasiswa,
                        id_jenis_pembiayaan: e.value.id,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            </>
          )}
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit" disabled={isLoading}>
              {isLoading ? "Loading..." : id ? "Update" : "Simpan"}
            </Button>
          ) : (
            <Button
              as={Link}
              type="submit"
              to="/profile-password"
              variant="warning"
            >
              Ganti Password
            </Button>
          )}
        </div>
      </Form>
    </Card.Body>
  );
};

export default Profile;
